import { render, staticRenderFns } from "./BlogTitle.vue?vue&type=template&id=ba7ba144&scoped=true&"
import script from "./BlogTitle.vue?vue&type=script&lang=js&"
export * from "./BlogTitle.vue?vue&type=script&lang=js&"
import style0 from "./BlogTitle.vue?vue&type=style&index=0&id=ba7ba144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7ba144",
  null
  
)

export default component.exports